import { makeStyles } from '@mui/styles'

const filledStyles = {
    transform: 'translateY(-100%) scale(.75)',
}

export default makeStyles((theme) => ({
    SearchField: {
        borderRadius: '9px',
        background: '#ffffff',
        minWidth: '0',
        '& fieldset': {
            // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
            border: `2px solid ${theme.palette.lightGrey.dark}`,
            '& legend': {
                width: '14rem',
            },
        },
        '& .MuiInputBase-input': {
            padding: '.75rem',
        },
        // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
        [theme.breakpoints.up(820)]: {
            minWidth: '24rem',
        },
        '& .MuiFormLabel-root': {
            top: -5,
        },
        '& .MuiFormLabel-root.MuiFormLabel-filled': filledStyles,
        '& .MuiFormLabel-root.Mui-focused': filledStyles,
        '& legend': {
            display: 'none',
        },
    },
    SearchFieldLabel: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '.5rem',
        top: '-2rem',
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        color: theme.palette.typography.mediumDark,
    },
    SearchFieldDialogPaper: {
        width: '90%',
        // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
        [theme.breakpoints.up(820)]: {
            width: 'auto',
        },
    },
    FormContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flexDirection: 'column',
        gap: '2rem',
        // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
        [theme.breakpoints.up(820)]: {
            minWidth: '18rem',
        },
    },
    FormGroup: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flexDirection: 'column',
        '& .MuiFormLabel-root': {
            marginBottom: '.5rem',
        },
    },
    FormControl: {
        width: '100%',
    },
    FormGroupContent: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flexDirection: 'column',
        gap: '1rem',
    },
    FormTextField: {
        width: '100%',
    },
    FormLabel: {
      fontFamily: 'AvertaPE-Bold',
      fontSize: '16px',
      fontWeight: '400px',
      color: '#24C3CF',
    },
    FormContainerBottom: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '1rem',
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        borderTop: `1px solid ${theme.palette.lightGrey.half}`,
        padding: '.5rem 0',
    },
    FormContainerBottomResetButton: {
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        color: theme.palette.red.main,
    },
}))
